import { render } from "./LocalSwitcher.vue?vue&type=template&id=bce81ba2"
import script from "./LocalSwitcher.vue?vue&type=script&lang=js"
export * from "./LocalSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "/home/luis/dev/nyxhotel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__